export default "__VITE_ASSET__4631bba4__"